import axiosInstance from "./api";
import { httpAPI } from "./status";

const isUseHttpAPi = (url: string, isUse: boolean) => {
  return isUse ? url : `${httpAPI}${url}`;
};

const httpForm = {
  postFormData: (url: string, formData: FormData, useInterNetAPI?: boolean) => {
    const realUrl = isUseHttpAPi(url, useInterNetAPI || false);
    // axios が自動で boundary を付与するため Content-Type を明示する必要は通常ありません
    return (axiosInstance as any).post(realUrl, formData, {
      headers: {
        // 必要なら追加のヘッダをここに設定
      },
    });
  },
};

export default httpForm;
